import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const FilterField = props => {
  const style = Object.assign({}, props.style, {
    flexGrow: props.flex ? props.flex : 1
  });

  return (
    <div className="filterField" style={style}>
      {props.label ? <label>{props.label}</label> : null}
      {props.children}
    </div>
  );
};

FilterField.propTypes = {
  label: PropTypes.string,
  children: PropTypeShapes.elementOrArray,
  style: PropTypes.object,
  flex: PropTypes.number
};

export default FilterField;
